import { PaginationResponse } from 'models/common/Pagination';
import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { ProjectExcp } from 'models/admin/ExcpPartner';

/**
 * 프로젝트별 협력업체 색상 목록
 * @param condition
 * */
export const findPrjExcpColorList = async (condition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/excp/color`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<ProjectExcp[]> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : []) as ProjectExcp[];
};

/**
 * 프로젝트별 협력업체 색상 등록/수정
 * @param condition
 */
export const savePrjExcpColor = async (excpList: ProjectExcp[]) => {
  const request: CommonRequest = {
    method: Method.PUT,
    url: '/v1/excp/color',
    serviceName: ServiceName.ELM_BE,
    bodyParams: excpList,
  };
  const response: CommonResponse<any> = await callApi(request);

  return response;
};
